// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionReason-cls1_6R0","cls2":"SuggestionReason-cls2_QMj SuggestionReason-cls1_6R0"};